/*
 * @Author: changdou.fe@bytedance.com
 * @Date: 2026-04-11 15:07:42
 * @LastEditors: changdou.fe@bytedance.com
 * @LastEditTime: 2026-04-11 15:32:19
 */
'use client';

import type React from 'react';
import { cn } from '@/lib/utils';

interface SimpleAvatarProps {
  width?: number;
  avatar?: string | null;
  name?: string | null;
  id?: string | number | null;
  showName?: boolean;
  handle?: string;
  userId?: string | number | null;
  className?: string;
  avatarClassName?: string;
  nameClassName?: string;
  idClassName?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

// 首字符大写
function getInitial(name?: string | null) {
  const firstChar = name?.trim()?.charAt(0) || '';
  if (!firstChar) return '';
  return /^[a-zA-Z]$/.test(firstChar) ? firstChar.toUpperCase() : firstChar;
}

export default function SimpleAvatar({
  avatar,
  name,
  id,
  handle,
  userId,
  className,
  avatarClassName,
  nameClassName,
  idClassName,
  style,
  showName = true,
  onClick,
}: SimpleAvatarProps) {
  const displayName = name?.trim() || '';
  const displayId = id === 0 || id ? String(id) : '';
  const initial = getInitial(displayName);
  const hasAvatar = Boolean(avatar);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (handle) {
      window.open(`/${handle}`, '_blank');
      return;
    }
    if (userId) {
      window.open(`/profile/detail?id=${userId}`, '_blank');
      return;
    }
    onClick?.(e);
  };

  return (
    <div className={cn('flex items-center justify-center gap-2', className)} style={style} onClick={handleClick}>
      <div
        className={cn(
          'flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-full bg-muted inline-block',
          avatarClassName
        )}
      >
        {hasAvatar ? (
          <img src={avatar || undefined} alt={displayName || 'avatar'} className="h-full w-full object-cover" />
        ) : (
          <span className="block w-full text-center text-xs font-semibold text-font-primary">{initial}</span>
        )}
      </div>
      {showName && (displayName || displayId) ? (
        <div className="min-w-0 flex flex-col">
          {displayName ? <span className={cn('truncate text-xs font-semibold text-font-primary', nameClassName)}>{displayName}</span> : null}
          {displayId ? <span className={cn('truncate text-xs text-font-primary/50', idClassName)}>{`ID: ${displayId}`}</span> : null}
        </div>
      ) : null}
    </div>
  );
}
